module.exports = __webpack_public_path__ + "static/img/spot-view-p1.62a2b83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spot-view-p1.png
// module id = S7L2
// module chunks = 1